/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var v = function() {
  return v = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, v.apply(this, arguments);
};
function Gt(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function E(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function N(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}
function k(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, a; n < i; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var L;
(function(e) {
  e.Start = "xstate.start", e.Stop = "xstate.stop", e.Raise = "xstate.raise", e.Send = "xstate.send", e.Cancel = "xstate.cancel", e.NullEvent = "", e.Assign = "xstate.assign", e.After = "xstate.after", e.DoneState = "done.state", e.DoneInvoke = "done.invoke", e.Log = "xstate.log", e.Init = "xstate.init", e.Invoke = "xstate.invoke", e.ErrorExecution = "error.execution", e.ErrorCommunication = "error.communication", e.ErrorPlatform = "error.platform", e.ErrorCustom = "xstate.error", e.Update = "xstate.update", e.Pure = "xstate.pure", e.Choose = "xstate.choose";
})(L || (L = {}));
var ot;
(function(e) {
  e.Parent = "#_parent", e.Internal = "#_internal";
})(ot || (ot = {}));
var Ct = L.Start, Xt = L.Stop, mt = L.Raise, It = L.Send, ae = L.Cancel, Ee = L.NullEvent, Yt = L.Assign;
L.After;
L.DoneState;
var oe = L.Log, Oe = L.Init, Mt = L.Invoke;
L.ErrorExecution;
var Wt = L.ErrorPlatform, Te = L.ErrorCustom, se = L.Update, Ne = L.Choose, Ae = L.Pure, ue = ".", Kt = {}, _t = "xstate.guard", je = "", M = process.env.NODE_ENV === "production", wt;
function qt(e, t, r) {
  r === void 0 && (r = ue);
  var n = pt(e, r), i = pt(t, r);
  return A(i) ? A(n) ? i === n : !1 : A(n) ? n in i : Object.keys(n).every(function(a) {
    return a in i ? qt(n[a], i[a]) : !1;
  });
}
function fe(e) {
  try {
    return A(e) || typeof e == "number" ? "".concat(e) : e.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function Ut(e, t) {
  try {
    return st(e) ? e : e.toString().split(t);
  } catch {
    throw new Error("'".concat(e, "' is not a valid state path."));
  }
}
function Pe(e) {
  return typeof e == "object" && "value" in e && "context" in e && "event" in e && "_event" in e;
}
function pt(e, t) {
  if (Pe(e))
    return e.value;
  if (st(e))
    return At(e);
  if (typeof e != "string")
    return e;
  var r = Ut(e, t);
  return At(r);
}
function At(e) {
  if (e.length === 1)
    return e[0];
  for (var t = {}, r = t, n = 0; n < e.length - 1; n++)
    n === e.length - 2 ? r[e[n]] = e[n + 1] : (r[e[n]] = {}, r = r[e[n]]);
  return t;
}
function ht(e, t) {
  for (var r = {}, n = Object.keys(e), i = 0; i < n.length; i++) {
    var a = n[i];
    r[a] = t(e[a], a, e, i);
  }
  return r;
}
function Zt(e, t, r) {
  var n, i, a = {};
  try {
    for (var o = E(Object.keys(e)), s = o.next(); !s.done; s = o.next()) {
      var u = s.value, f = e[u];
      r(f) && (a[u] = t(f, u, e));
    }
  } catch (h) {
    n = {
      error: h
    };
  } finally {
    try {
      s && !s.done && (i = o.return) && i.call(o);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return a;
}
var Le = function(e) {
  return function(t) {
    var r, n, i = t;
    try {
      for (var a = E(e), o = a.next(); !o.done; o = a.next()) {
        var s = o.value;
        i = i[s];
      }
    } catch (u) {
      r = {
        error: u
      };
    } finally {
      try {
        o && !o.done && (n = a.return) && n.call(a);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return i;
  };
};
function Ie(e, t) {
  return function(r) {
    var n, i, a = r;
    try {
      for (var o = E(e), s = o.next(); !s.done; s = o.next()) {
        var u = s.value;
        a = a[t][u];
      }
    } catch (f) {
      n = {
        error: f
      };
    } finally {
      try {
        s && !s.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return a;
  };
}
function Et(e) {
  if (!e)
    return [[]];
  if (A(e))
    return [[e]];
  var t = C(Object.keys(e).map(function(r) {
    var n = e[r];
    return typeof n != "string" && (!n || !Object.keys(n).length) ? [[r]] : Et(e[r]).map(function(i) {
      return [r].concat(i);
    });
  }));
  return t;
}
function C(e) {
  var t;
  return (t = []).concat.apply(t, k([], N(e), !1));
}
function ce(e) {
  return st(e) ? e : [e];
}
function q(e) {
  return e === void 0 ? [] : ce(e);
}
function jt(e, t, r) {
  var n, i;
  if (j(e))
    return e(t, r.data);
  var a = {};
  try {
    for (var o = E(Object.keys(e)), s = o.next(); !s.done; s = o.next()) {
      var u = s.value, f = e[u];
      j(f) ? a[u] = f(t, r.data) : a[u] = f;
    }
  } catch (h) {
    n = {
      error: h
    };
  } finally {
    try {
      s && !s.done && (i = o.return) && i.call(o);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return a;
}
function Re(e) {
  return /^(done|error)\./.test(e);
}
function Ht(e) {
  return !!(e instanceof Promise || e !== null && (j(e) || typeof e == "object") && j(e.then));
}
function De(e) {
  return e !== null && typeof e == "object" && "transition" in e && typeof e.transition == "function";
}
function ke(e, t) {
  var r, n, i = N([[], []], 2), a = i[0], o = i[1];
  try {
    for (var s = E(e), u = s.next(); !u.done; u = s.next()) {
      var f = u.value;
      t(f) ? a.push(f) : o.push(f);
    }
  } catch (h) {
    r = {
      error: h
    };
  } finally {
    try {
      u && !u.done && (n = s.return) && n.call(s);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return [a, o];
}
function he(e, t) {
  return ht(e.states, function(r, n) {
    if (r) {
      var i = (A(t) ? void 0 : t[n]) || (r ? r.current : void 0);
      if (i)
        return {
          current: i,
          states: he(r, i)
        };
    }
  });
}
function Ce(e, t) {
  return {
    current: t,
    states: he(e, t)
  };
}
function te(e, t, r, n) {
  M || $(!!e, "Attempting to update undefined context");
  var i = e && r.reduce(function(a, o) {
    var s, u, f = o.assignment, h = {
      state: n,
      action: o,
      _event: t
    }, l = {};
    if (j(f))
      l = f(a, t.data, h);
    else
      try {
        for (var c = E(Object.keys(f)), d = c.next(); !d.done; d = c.next()) {
          var y = d.value, p = f[y];
          l[y] = j(p) ? p(a, t.data, h) : p;
        }
      } catch (S) {
        s = {
          error: S
        };
      } finally {
        try {
          d && !d.done && (u = c.return) && u.call(c);
        } finally {
          if (s)
            throw s.error;
        }
      }
    return Object.assign({}, a, l);
  }, e);
  return i;
}
var $ = function() {
};
M || ($ = function(e, t) {
  var r = e instanceof Error ? e : void 0;
  if (!(!r && e) && console !== void 0) {
    var n = ["Warning: ".concat(t)];
    r && n.push(r), console.warn.apply(console, n);
  }
});
function st(e) {
  return Array.isArray(e);
}
function j(e) {
  return typeof e == "function";
}
function A(e) {
  return typeof e == "string";
}
function le(e, t) {
  if (e)
    return A(e) ? {
      type: _t,
      name: e,
      predicate: t ? t[e] : void 0
    } : j(e) ? {
      type: _t,
      name: e.name,
      predicate: e
    } : e;
}
function Me(e) {
  try {
    return "subscribe" in e && j(e.subscribe);
  } catch {
    return !1;
  }
}
var B = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
wt = {}, wt[B] = function() {
  return this;
}, wt[Symbol.observable] = function() {
  return this;
};
function Z(e) {
  return !!e && "__xstatenode" in e;
}
function _e(e) {
  return !!e && typeof e.send == "function";
}
function Rt(e, t) {
  return A(e) || typeof e == "number" ? v({
    type: e
  }, t) : e;
}
function F(e, t) {
  if (!A(e) && "$$type" in e && e.$$type === "scxml")
    return e;
  var r = Rt(e);
  return v({
    name: r.type,
    data: r,
    $$type: "scxml",
    type: "external"
  }, t);
}
function tt(e, t) {
  var r = ce(t).map(function(n) {
    return typeof n > "u" || typeof n == "string" || Z(n) ? {
      target: n,
      event: e
    } : v(v({}, n), {
      event: e
    });
  });
  return r;
}
function Ue(e) {
  if (!(e === void 0 || e === je))
    return q(e);
}
function ze(e, t, r) {
  if (!M) {
    var n = e.stack ? " Stacktrace was '".concat(e.stack, "'") : "";
    if (e === t)
      console.error("Missing onError handler for invocation '".concat(r, "', error was '").concat(e, "'.").concat(n));
    else {
      var i = t.stack ? " Stacktrace was '".concat(t.stack, "'") : "";
      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(r, "'. ") + "Original error: '".concat(e, "'. ").concat(n, " Current error is '").concat(t, "'.").concat(i));
    }
  }
}
function de(e, t, r, n, i) {
  var a = e.options.guards, o = {
    state: i,
    cond: t,
    _event: n
  };
  if (t.type === _t)
    return ((a == null ? void 0 : a[t.name]) || t.predicate)(r, n.data, o);
  var s = a == null ? void 0 : a[t.type];
  if (!s)
    throw new Error("Guard '".concat(t.type, "' is not implemented on machine '").concat(e.id, "'."));
  return s(r, n.data, o);
}
function ve(e) {
  return typeof e == "string" ? {
    type: e
  } : e;
}
function Ot(e, t, r) {
  var n = function() {
  }, i = typeof e == "object", a = i ? e : null;
  return {
    next: ((i ? e.next : e) || n).bind(a),
    error: ((i ? e.error : t) || n).bind(a),
    complete: ((i ? e.complete : r) || n).bind(a)
  };
}
function St(e, t) {
  return "".concat(e, ":invocation[").concat(t, "]");
}
function zt(e) {
  return (e.type === mt || e.type === It && e.to === ot.Internal) && typeof e.delay != "number";
}
var at = /* @__PURE__ */ F({
  type: Oe
});
function Ft(e, t) {
  return t && t[e] || void 0;
}
function yt(e, t) {
  var r;
  if (A(e) || typeof e == "number") {
    var n = Ft(e, t);
    j(n) ? r = {
      type: e,
      exec: n
    } : n ? r = n : r = {
      type: e,
      exec: void 0
    };
  } else if (j(e))
    r = {
      // Convert action to string if unnamed
      type: e.name || e.toString(),
      exec: e
    };
  else {
    var n = Ft(e.type, t);
    if (j(n))
      r = v(v({}, e), {
        exec: n
      });
    else if (n) {
      var i = n.type || e.type;
      r = v(v(v({}, n), e), {
        type: i
      });
    } else
      r = e;
  }
  return r;
}
var W = function(e, t) {
  if (!e)
    return [];
  var r = st(e) ? e : [e];
  return r.map(function(n) {
    return yt(n, t);
  });
};
function Qt(e) {
  var t = yt(e);
  return v(v({
    id: A(e) ? e : t.id
  }, t), {
    type: t.type
  });
}
function Fe(e, t) {
  return {
    type: mt,
    event: typeof e == "function" ? e : Rt(e),
    delay: t ? t.delay : void 0,
    id: t == null ? void 0 : t.id
  };
}
function $e(e, t, r, n) {
  var i = {
    _event: r
  }, a = F(j(e.event) ? e.event(t, r.data, i) : e.event), o;
  if (A(e.delay)) {
    var s = n && n[e.delay];
    o = j(s) ? s(t, r.data, i) : s;
  } else
    o = j(e.delay) ? e.delay(t, r.data, i) : e.delay;
  return v(v({}, e), {
    type: mt,
    _event: a,
    delay: o
  });
}
function Je(e, t) {
  return {
    to: t ? t.to : void 0,
    type: It,
    event: j(e) ? e : Rt(e),
    delay: t ? t.delay : void 0,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: t && t.id !== void 0 ? t.id : j(e) ? e.name : fe(e)
  };
}
function Ge(e, t, r, n) {
  var i = {
    _event: r
  }, a = F(j(e.event) ? e.event(t, r.data, i) : e.event), o;
  if (A(e.delay)) {
    var s = n && n[e.delay];
    o = j(s) ? s(t, r.data, i) : s;
  } else
    o = j(e.delay) ? e.delay(t, r.data, i) : e.delay;
  var u = j(e.to) ? e.to(t, r.data, i) : e.to;
  return v(v({}, e), {
    to: u,
    _event: a,
    event: a.data,
    delay: o
  });
}
var Xe = function(e, t, r) {
  return v(v({}, e), {
    value: A(e.expr) ? e.expr : e.expr(t, r.data, {
      _event: r
    })
  });
}, Ye = function(e) {
  return {
    type: ae,
    sendId: e
  };
};
function qe(e) {
  var t = Qt(e);
  return {
    type: L.Start,
    activity: t,
    exec: void 0
  };
}
function Qe(e) {
  var t = j(e) ? e : Qt(e);
  return {
    type: L.Stop,
    activity: t,
    exec: void 0
  };
}
function Ve(e, t, r) {
  var n = j(e.activity) ? e.activity(t, r.data) : e.activity, i = typeof n == "string" ? {
    id: n
  } : n, a = {
    type: L.Stop,
    activity: i
  };
  return a;
}
var Be = function(e) {
  return {
    type: Yt,
    assignment: e
  };
};
function We(e, t) {
  var r = t ? "#".concat(t) : "";
  return "".concat(L.After, "(").concat(e, ")").concat(r);
}
function xt(e, t) {
  var r = "".concat(L.DoneState, ".").concat(e), n = {
    type: r,
    data: t
  };
  return n.toString = function() {
    return r;
  }, n;
}
function Tt(e, t) {
  var r = "".concat(L.DoneInvoke, ".").concat(e), n = {
    type: r,
    data: t
  };
  return n.toString = function() {
    return r;
  }, n;
}
function lt(e, t) {
  var r = "".concat(L.ErrorPlatform, ".").concat(e), n = {
    type: r,
    data: t
  };
  return n.toString = function() {
    return r;
  }, n;
}
var Ke = function(e) {
  var t, r, n = [];
  try {
    for (var i = E(e), a = i.next(); !a.done; a = i.next())
      for (var o = a.value, s = 0; s < o.actions.length; ) {
        if (o.actions[s].type === Yt) {
          n.push(o.actions[s]), o.actions.splice(s, 1);
          continue;
        }
        s++;
      }
  } catch (u) {
    t = {
      error: u
    };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return n;
};
function Pt(e, t, r, n, i, a, o) {
  o === void 0 && (o = !1);
  var s = o ? [] : Ke(i), u = s.length ? te(r, n, s, t) : r, f = o ? [r] : void 0, h = [];
  function l(y, p) {
    var S;
    switch (p.type) {
      case mt: {
        var m = $e(p, u, n, e.options.delays);
        return a && typeof m.delay == "number" && a(m, u, n), m;
      }
      case It:
        var g = Ge(p, u, n, e.options.delays);
        if (!M) {
          var w = p.delay;
          $(
            !A(w) || typeof g.delay == "number",
            // tslint:disable-next-line:max-line-length
            "No delay reference for delay expression '".concat(w, "' was found on machine '").concat(e.id, "'")
          );
        }
        return a && g.to !== ot.Internal && (y === "entry" ? h.push(g) : a(g, u, n)), g;
      case oe: {
        var x = Xe(p, u, n);
        return a == null || a(x, u, n), x;
      }
      case Ne: {
        var R = p, P = (S = R.conds.find(function(K) {
          var V = le(K.cond, e.options.guards);
          return !V || de(e, V, u, n, a ? void 0 : t);
        })) === null || S === void 0 ? void 0 : S.actions;
        if (!P)
          return [];
        var T = N(Pt(e, t, u, n, [{
          type: y,
          actions: W(q(P), e.options.actions)
        }], a, o), 2), I = T[0], O = T[1];
        return u = O, f == null || f.push(u), I;
      }
      case Ae: {
        var P = p.get(u, n.data);
        if (!P)
          return [];
        var _ = N(Pt(e, t, u, n, [{
          type: y,
          actions: W(q(P), e.options.actions)
        }], a, o), 2), b = _[0], D = _[1];
        return u = D, f == null || f.push(u), b;
      }
      case Xt: {
        var x = Ve(p, u, n);
        return a == null || a(x, r, n), x;
      }
      case Yt: {
        u = te(u, n, [p], a ? void 0 : t), f == null || f.push(u);
        break;
      }
      default:
        var z = yt(p, e.options.actions), J = z.exec;
        if (a)
          a(z, u, n);
        else if (J && f) {
          var ut = f.length - 1, Dt = v(v({}, z), {
            exec: function(K) {
              for (var V = [], G = 1; G < arguments.length; G++)
                V[G - 1] = arguments[G];
              J.apply(void 0, k([f[ut]], N(V), !1));
            }
          });
          z = Dt;
        }
        return z;
    }
  }
  function c(y) {
    var p, S, m = [];
    try {
      for (var g = E(y.actions), w = g.next(); !w.done; w = g.next()) {
        var x = w.value, R = l(y.type, x);
        R && (m = m.concat(R));
      }
    } catch (P) {
      p = {
        error: P
      };
    } finally {
      try {
        w && !w.done && (S = g.return) && S.call(g);
      } finally {
        if (p)
          throw p.error;
      }
    }
    return h.forEach(function(P) {
      a(P, u, n);
    }), h.length = 0, m;
  }
  var d = C(i.map(c));
  return [d, u];
}
var ee = [], nt = function(e, t) {
  ee.push(e);
  var r = t(e);
  return ee.pop(), r;
};
function pe(e) {
  var t;
  return t = {
    id: e,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: e
      };
    }
  }, t[B] = function() {
    return this;
  }, t;
}
function Ze(e, t, r, n) {
  var i, a = ve(e.src), o = (i = t == null ? void 0 : t.options.services) === null || i === void 0 ? void 0 : i[a.type], s = e.data ? jt(e.data, r, n) : void 0, u = o ? ye(o, e.id, s) : pe(e.id);
  return u.meta = e, u;
}
function ye(e, t, r) {
  var n = pe(t);
  if (n.deferred = !0, Z(e)) {
    var i = n.state = nt(void 0, function() {
      return (r ? e.withContext(r) : e).initialState;
    });
    n.getSnapshot = function() {
      return i;
    };
  }
  return n;
}
function He(e) {
  try {
    return typeof e.send == "function";
  } catch {
    return !1;
  }
}
function tr(e) {
  return He(e) && "id" in e;
}
function er(e) {
  var t;
  return v((t = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, t[B] = function() {
    return this;
  }, t), e);
}
var Lt = function(e) {
  return e.type === "atomic" || e.type === "final";
};
function ge(e) {
  return Object.keys(e.states).map(function(t) {
    return e.states[t];
  });
}
function gt(e) {
  return ge(e).filter(function(t) {
    return t.type !== "history";
  });
}
function me(e) {
  var t = [e];
  return Lt(e) ? t : t.concat(C(gt(e).map(me)));
}
function dt(e, t) {
  var r, n, i, a, o, s, u, f, h = new Set(e), l = $t(h), c = new Set(t);
  try {
    for (var d = E(c), y = d.next(); !y.done; y = d.next())
      for (var p = y.value, S = p.parent; S && !c.has(S); )
        c.add(S), S = S.parent;
  } catch (O) {
    r = {
      error: O
    };
  } finally {
    try {
      y && !y.done && (n = d.return) && n.call(d);
    } finally {
      if (r)
        throw r.error;
    }
  }
  var m = $t(c);
  try {
    for (var g = E(c), w = g.next(); !w.done; w = g.next()) {
      var p = w.value;
      if (p.type === "compound" && (!m.get(p) || !m.get(p).length))
        l.get(p) ? l.get(p).forEach(function(_) {
          return c.add(_);
        }) : p.initialStateNodes.forEach(function(_) {
          return c.add(_);
        });
      else if (p.type === "parallel")
        try {
          for (var x = (o = void 0, E(gt(p))), R = x.next(); !R.done; R = x.next()) {
            var P = R.value;
            c.has(P) || (c.add(P), l.get(P) ? l.get(P).forEach(function(_) {
              return c.add(_);
            }) : P.initialStateNodes.forEach(function(_) {
              return c.add(_);
            }));
          }
        } catch (_) {
          o = {
            error: _
          };
        } finally {
          try {
            R && !R.done && (s = x.return) && s.call(x);
          } finally {
            if (o)
              throw o.error;
          }
        }
    }
  } catch (O) {
    i = {
      error: O
    };
  } finally {
    try {
      w && !w.done && (a = g.return) && a.call(g);
    } finally {
      if (i)
        throw i.error;
    }
  }
  try {
    for (var T = E(c), I = T.next(); !I.done; I = T.next())
      for (var p = I.value, S = p.parent; S && !c.has(S); )
        c.add(S), S = S.parent;
  } catch (O) {
    u = {
      error: O
    };
  } finally {
    try {
      I && !I.done && (f = T.return) && f.call(T);
    } finally {
      if (u)
        throw u.error;
    }
  }
  return c;
}
function we(e, t) {
  var r = t.get(e);
  if (!r)
    return {};
  if (e.type === "compound") {
    var n = r[0];
    if (n) {
      if (Lt(n))
        return n.key;
    } else
      return {};
  }
  var i = {};
  return r.forEach(function(a) {
    i[a.key] = we(a, t);
  }), i;
}
function $t(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = E(e), a = i.next(); !a.done; a = i.next()) {
      var o = a.value;
      n.has(o) || n.set(o, []), o.parent && (n.has(o.parent) || n.set(o.parent, []), n.get(o.parent).push(o));
    }
  } catch (s) {
    t = {
      error: s
    };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return n;
}
function rr(e, t) {
  var r = dt([e], t);
  return we(e, $t(r));
}
function vt(e, t) {
  return Array.isArray(e) ? e.some(function(r) {
    return r === t;
  }) : e instanceof Set ? e.has(t) : !1;
}
function nr(e) {
  return k([], N(new Set(C(k([], N(e.map(function(t) {
    return t.ownEvents;
  })), !1)))), !1);
}
function Nt(e, t) {
  return t.type === "compound" ? gt(t).some(function(r) {
    return r.type === "final" && vt(e, r);
  }) : t.type === "parallel" ? gt(t).every(function(r) {
    return Nt(e, r);
  }) : !1;
}
function ir(e) {
  return e === void 0 && (e = []), e.reduce(function(t, r) {
    return r.meta !== void 0 && (t[r.id] = r.meta), t;
  }, {});
}
function re(e) {
  return new Set(C(e.map(function(t) {
    return t.tags;
  })));
}
function Se(e, t) {
  if (e === t)
    return !0;
  if (e === void 0 || t === void 0)
    return !1;
  if (A(e) || A(t))
    return e === t;
  var r = Object.keys(e), n = Object.keys(t);
  return r.length === n.length && r.every(function(i) {
    return Se(e[i], t[i]);
  });
}
function ar(e) {
  return typeof e != "object" || e === null ? !1 : "value" in e && "_event" in e;
}
function or(e, t) {
  var r = e.exec, n = v(v({}, e), {
    exec: r !== void 0 ? function() {
      return r(t.context, t.event, {
        action: e,
        state: t,
        _event: t._event
      });
    } : void 0
  });
  return n;
}
var Q = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this, n;
      this.actions = [], this.activities = Kt, this.meta = {}, this.events = [], this.value = t.value, this.context = t.context, this._event = t._event, this._sessionid = t._sessionid, this.event = this._event.data, this.historyValue = t.historyValue, this.history = t.history, this.actions = t.actions || [], this.activities = t.activities || Kt, this.meta = ir(t.configuration), this.events = t.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = t.configuration, this.transitions = t.transitions, this.children = t.children, this.done = !!t.done, this.tags = (n = Array.isArray(t.tags) ? new Set(t.tags) : t.tags) !== null && n !== void 0 ? n : /* @__PURE__ */ new Set(), this.machine = t.machine, Object.defineProperty(this, "nextEvents", {
        get: function() {
          return nr(r.configuration);
        }
      });
    }
    return e.from = function(t, r) {
      if (t instanceof e)
        return t.context !== r ? new e({
          value: t.value,
          context: r,
          _event: t._event,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          actions: [],
          activities: t.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        }) : t;
      var n = at;
      return new e({
        value: t,
        context: r,
        _event: n,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        meta: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, e.create = function(t) {
      return new e(t);
    }, e.inert = function(t, r) {
      if (t instanceof e) {
        if (!t.actions.length)
          return t;
        var n = at;
        return new e({
          value: t.value,
          context: r,
          _event: n,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          activities: t.activities,
          configuration: t.configuration,
          transitions: [],
          children: {}
        });
      }
      return e.from(t, r);
    }, e.prototype.toStrings = function(t, r) {
      var n = this;
      if (t === void 0 && (t = this.value), r === void 0 && (r = "."), A(t))
        return [t];
      var i = Object.keys(t);
      return i.concat.apply(i, k([], N(i.map(function(a) {
        return n.toStrings(t[a], r).map(function(o) {
          return a + r + o;
        });
      })), !1));
    }, e.prototype.toJSON = function() {
      var t = this;
      t.configuration, t.transitions;
      var r = t.tags;
      t.machine;
      var n = Gt(t, ["configuration", "transitions", "tags", "machine"]);
      return v(v({}, n), {
        tags: Array.from(r)
      });
    }, e.prototype.matches = function(t) {
      return qt(t, this.value);
    }, e.prototype.hasTag = function(t) {
      return this.tags.has(t);
    }, e.prototype.can = function(t) {
      var r;
      M && $(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
      var n = (r = this.machine) === null || r === void 0 ? void 0 : r.getTransitionData(this, t);
      return !!(n != null && n.transitions.length) && // Check that at least one transition is not forbidden
      n.transitions.some(function(i) {
        return i.target !== void 0 || i.actions.length;
      });
    }, e;
  }()
), sr = {
  deferEvents: !1
}, ne = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = v(v({}, sr), t);
    }
    return e.prototype.initialize = function(t) {
      if (this.initialized = !0, t) {
        if (!this.options.deferEvents) {
          this.schedule(t);
          return;
        }
        this.process(t);
      }
      this.flushEvents();
    }, e.prototype.schedule = function(t) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(t);
        return;
      }
      if (this.queue.length !== 0)
        throw new Error("Event queue should be empty when it is not processing events");
      this.process(t), this.flushEvents();
    }, e.prototype.clear = function() {
      this.queue = [];
    }, e.prototype.flushEvents = function() {
      for (var t = this.queue.shift(); t; )
        this.process(t), t = this.queue.shift();
    }, e.prototype.process = function(t) {
      this.processingEvent = !0;
      try {
        t();
      } catch (r) {
        throw this.clear(), r;
      } finally {
        this.processingEvent = !1;
      }
    }, e;
  }()
), kt = /* @__PURE__ */ new Map(), ur = 0, ft = {
  bookId: function() {
    return "x:".concat(ur++);
  },
  register: function(e, t) {
    return kt.set(e, t), e;
  },
  get: function(e) {
    return kt.get(e);
  },
  free: function(e) {
    kt.delete(e);
  }
};
function Vt() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  M || console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function fr() {
  var e = Vt();
  if (e && "__xstate__" in e)
    return e.__xstate__;
}
function cr(e) {
  if (Vt()) {
    var t = fr();
    t && t.register(e);
  }
}
function hr(e, t) {
  t === void 0 && (t = {});
  var r = e.initialState, n = /* @__PURE__ */ new Set(), i = [], a = !1, o = function() {
    if (!a) {
      for (a = !0; i.length > 0; ) {
        var f = i.shift();
        r = e.transition(r, f, u), n.forEach(function(h) {
          return h.next(r);
        });
      }
      a = !1;
    }
  }, s = er({
    id: t.id,
    send: function(f) {
      i.push(f), o();
    },
    getSnapshot: function() {
      return r;
    },
    subscribe: function(f, h, l) {
      var c = Ot(f, h, l);
      return n.add(c), c.next(r), {
        unsubscribe: function() {
          n.delete(c);
        }
      };
    }
  }), u = {
    parent: t.parent,
    self: s,
    id: t.id || "anonymous",
    observers: n
  };
  return r = e.start ? e.start(u) : r, s;
}
var lr = {
  sync: !1,
  autoForward: !1
}, U;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(U || (U = {}));
var dr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r) {
      r === void 0 && (r = e.defaultOptions);
      var n = this;
      this.machine = t, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = !1, this.status = U.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this._outgoingQueue = [], this.init = this.start, this.send = function(h, l) {
        if (st(h))
          return n.batch(h), n.state;
        var c = F(Rt(h, l));
        if (n.status === U.Stopped)
          return M || $(!1, 'Event "'.concat(c.name, '" was sent to stopped service "').concat(n.machine.id, `". This service has already reached its final state, and will not transition.
Event: `).concat(JSON.stringify(c.data))), n.state;
        if (n.status !== U.Running && !n.options.deferEvents)
          throw new Error('Event "'.concat(c.name, '" was sent to uninitialized service "').concat(
            n.machine.id,
            `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
          ).concat(JSON.stringify(c.data)));
        return n.scheduler.schedule(function() {
          n.forward(c);
          var d = n._nextState(c);
          n.update(d, c);
        }), n._state;
      }, this.sendTo = function(h, l, c) {
        var d = n.parent && (l === ot.Parent || n.parent.id === l), y = d ? n.parent : A(l) ? l === ot.Internal ? n : n.children.get(l) || ft.get(l) : _e(l) ? l : void 0;
        if (!y) {
          if (!d)
            throw new Error("Unable to send event to child '".concat(l, "' from service '").concat(n.id, "'."));
          M || $(!1, "Service '".concat(n.id, "' has no parent: unable to send event ").concat(h.type));
          return;
        }
        if ("machine" in y) {
          if (n.status !== U.Stopped || n.parent !== y || // we need to send events to the parent from exit handlers of a machine that reached its final state
          n.state.done) {
            var p = v(v({}, h), {
              name: h.name === Te ? "".concat(lt(n.id)) : h.name,
              origin: n.sessionId
            });
            !c && n.machine.config.predictableActionArguments ? n._outgoingQueue.push([y, p]) : y.send(p);
          }
        } else
          !c && n.machine.config.predictableActionArguments ? n._outgoingQueue.push([y, h.data]) : y.send(h.data);
      }, this._exec = function(h, l, c, d) {
        d === void 0 && (d = n.machine.options.actions);
        var y = h.exec || Ft(h.type, d), p = j(y) ? y : y ? y.exec : h.exec;
        if (p)
          try {
            return p(l, c.data, n.machine.config.predictableActionArguments ? {
              action: h,
              _event: c
            } : {
              action: h,
              state: n.state,
              _event: c
            });
          } catch (J) {
            throw n.parent && n.parent.send({
              type: "xstate.error",
              data: J
            }), J;
          }
        switch (h.type) {
          case mt: {
            var S = h;
            n.defer(S);
            break;
          }
          case It:
            var m = h;
            if (typeof m.delay == "number") {
              n.defer(m);
              return;
            } else
              m.to ? n.sendTo(m._event, m.to, c === at) : n.send(m._event);
            break;
          case ae:
            n.cancel(h.sendId);
            break;
          case Ct: {
            if (n.status !== U.Running)
              return;
            var g = h.activity;
            if (
              // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
              !n.machine.config.predictableActionArguments && !n.state.activities[g.id || g.type]
            )
              break;
            if (g.type === L.Invoke) {
              var w = ve(g.src), x = n.machine.options.services ? n.machine.options.services[w.type] : void 0, R = g.id, P = g.data;
              M || $(
                !("forward" in g),
                // tslint:disable-next-line:max-line-length
                "`forward` property is deprecated (found in invocation of '".concat(g.src, "' in in machine '").concat(n.machine.id, "'). ") + "Please use `autoForward` instead."
              );
              var T = "autoForward" in g ? g.autoForward : !!g.forward;
              if (!x) {
                M || $(!1, "No service found for invocation '".concat(g.src, "' in machine '").concat(n.machine.id, "'."));
                return;
              }
              var I = P ? jt(P, l, c) : void 0;
              if (typeof x == "string")
                return;
              var O = j(x) ? x(l, c.data, {
                data: I,
                src: w,
                meta: g.meta
              }) : x;
              if (!O)
                return;
              var _ = void 0;
              Z(O) && (O = I ? O.withContext(I) : O, _ = {
                autoForward: T
              }), n.spawn(O, R, _);
            } else
              n.spawnActivity(g);
            break;
          }
          case Xt: {
            n.stopChild(h.activity.id);
            break;
          }
          case oe:
            var b = h, D = b.label, z = b.value;
            D ? n.logger(D, z) : n.logger(z);
            break;
          default:
            M || $(!1, "No implementation found for action type '".concat(h.type, "'"));
            break;
        }
      };
      var i = v(v({}, e.defaultOptions), r), a = i.clock, o = i.logger, s = i.parent, u = i.id, f = u !== void 0 ? u : t.id;
      this.id = f, this.logger = o, this.clock = a, this.parent = s, this.options = i, this.scheduler = new ne({
        deferEvents: this.options.deferEvents
      }), this.sessionId = ft.bookId();
    }
    return Object.defineProperty(e.prototype, "initialState", {
      get: function() {
        var t = this;
        return this._initialState ? this._initialState : nt(this, function() {
          return t._initialState = t.machine.initialState, t._initialState;
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "state", {
      /**
       * @deprecated Use `.getSnapshot()` instead.
       */
      get: function() {
        return M || $(this.status !== U.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first.")), this._state;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.execute = function(t, r) {
      var n, i;
      try {
        for (var a = E(t.actions), o = a.next(); !o.done; o = a.next()) {
          var s = o.value;
          this.exec(s, t, r);
        }
      } catch (u) {
        n = {
          error: u
        };
      } finally {
        try {
          o && !o.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, e.prototype.update = function(t, r) {
      var n, i, a, o, s, u, f, h, l = this;
      if (t._sessionid = this.sessionId, this._state = t, (!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
      // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
      r === at) && this.options.execute)
        this.execute(this.state);
      else
        for (var c = void 0; c = this._outgoingQueue.shift(); )
          c[0].send(c[1]);
      if (this.children.forEach(function(O) {
        l.state.children[O.id] = O;
      }), this.devTools && this.devTools.send(r.data, t), t.event)
        try {
          for (var d = E(this.eventListeners), y = d.next(); !y.done; y = d.next()) {
            var p = y.value;
            p(t.event);
          }
        } catch (O) {
          n = {
            error: O
          };
        } finally {
          try {
            y && !y.done && (i = d.return) && i.call(d);
          } finally {
            if (n)
              throw n.error;
          }
        }
      try {
        for (var S = E(this.listeners), m = S.next(); !m.done; m = S.next()) {
          var p = m.value;
          p(t, t.event);
        }
      } catch (O) {
        a = {
          error: O
        };
      } finally {
        try {
          m && !m.done && (o = S.return) && o.call(S);
        } finally {
          if (a)
            throw a.error;
        }
      }
      try {
        for (var g = E(this.contextListeners), w = g.next(); !w.done; w = g.next()) {
          var x = w.value;
          x(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (O) {
        s = {
          error: O
        };
      } finally {
        try {
          w && !w.done && (u = g.return) && u.call(g);
        } finally {
          if (s)
            throw s.error;
        }
      }
      if (this.state.done) {
        var R = t.configuration.find(function(O) {
          return O.type === "final" && O.parent === l.machine;
        }), P = R && R.doneData ? jt(R.doneData, t.context, r) : void 0;
        this._doneEvent = Tt(this.id, P);
        try {
          for (var T = E(this.doneListeners), I = T.next(); !I.done; I = T.next()) {
            var p = I.value;
            p(this._doneEvent);
          }
        } catch (O) {
          f = {
            error: O
          };
        } finally {
          try {
            I && !I.done && (h = T.return) && h.call(T);
          } finally {
            if (f)
              throw f.error;
          }
        }
        this._stop(), this._stopChildren(), ft.free(this.sessionId);
      }
    }, e.prototype.onTransition = function(t) {
      return this.listeners.add(t), this.status === U.Running && t(this.state, this.state.event), this;
    }, e.prototype.subscribe = function(t, r, n) {
      var i = this, a = Ot(t, r, n);
      this.listeners.add(a.next), this.status !== U.NotStarted && a.next(this.state);
      var o = function() {
        i.doneListeners.delete(o), i.stopListeners.delete(o), a.complete();
      };
      return this.status === U.Stopped ? a.complete() : (this.onDone(o), this.onStop(o)), {
        unsubscribe: function() {
          i.listeners.delete(a.next), i.doneListeners.delete(o), i.stopListeners.delete(o);
        }
      };
    }, e.prototype.onEvent = function(t) {
      return this.eventListeners.add(t), this;
    }, e.prototype.onSend = function(t) {
      return this.sendListeners.add(t), this;
    }, e.prototype.onChange = function(t) {
      return this.contextListeners.add(t), this;
    }, e.prototype.onStop = function(t) {
      return this.stopListeners.add(t), this;
    }, e.prototype.onDone = function(t) {
      return this.status === U.Stopped && this._doneEvent ? t(this._doneEvent) : this.doneListeners.add(t), this;
    }, e.prototype.off = function(t) {
      return this.listeners.delete(t), this.eventListeners.delete(t), this.sendListeners.delete(t), this.stopListeners.delete(t), this.doneListeners.delete(t), this.contextListeners.delete(t), this;
    }, e.prototype.start = function(t) {
      var r = this;
      if (this.status === U.Running)
        return this;
      this.machine._init(), ft.register(this.sessionId, this), this.initialized = !0, this.status = U.Running;
      var n = t === void 0 ? this.initialState : nt(this, function() {
        return ar(t) ? r.machine.resolveState(t) : r.machine.resolveState(Q.from(t, r.machine.context));
      });
      return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
        r.update(n, at);
      }), this;
    }, e.prototype._stopChildren = function() {
      this.children.forEach(function(t) {
        j(t.stop) && t.stop();
      }), this.children.clear();
    }, e.prototype._stop = function() {
      var t, r, n, i, a, o, s, u, f, h;
      try {
        for (var l = E(this.listeners), c = l.next(); !c.done; c = l.next()) {
          var d = c.value;
          this.listeners.delete(d);
        }
      } catch (T) {
        t = {
          error: T
        };
      } finally {
        try {
          c && !c.done && (r = l.return) && r.call(l);
        } finally {
          if (t)
            throw t.error;
        }
      }
      try {
        for (var y = E(this.stopListeners), p = y.next(); !p.done; p = y.next()) {
          var d = p.value;
          d(), this.stopListeners.delete(d);
        }
      } catch (T) {
        n = {
          error: T
        };
      } finally {
        try {
          p && !p.done && (i = y.return) && i.call(y);
        } finally {
          if (n)
            throw n.error;
        }
      }
      try {
        for (var S = E(this.contextListeners), m = S.next(); !m.done; m = S.next()) {
          var d = m.value;
          this.contextListeners.delete(d);
        }
      } catch (T) {
        a = {
          error: T
        };
      } finally {
        try {
          m && !m.done && (o = S.return) && o.call(S);
        } finally {
          if (a)
            throw a.error;
        }
      }
      try {
        for (var g = E(this.doneListeners), w = g.next(); !w.done; w = g.next()) {
          var d = w.value;
          this.doneListeners.delete(d);
        }
      } catch (T) {
        s = {
          error: T
        };
      } finally {
        try {
          w && !w.done && (u = g.return) && u.call(g);
        } finally {
          if (s)
            throw s.error;
        }
      }
      if (!this.initialized)
        return this;
      this.initialized = !1, this.status = U.Stopped, this._initialState = void 0;
      try {
        for (var x = E(Object.keys(this.delayedEventsMap)), R = x.next(); !R.done; R = x.next()) {
          var P = R.value;
          this.clock.clearTimeout(this.delayedEventsMap[P]);
        }
      } catch (T) {
        f = {
          error: T
        };
      } finally {
        try {
          R && !R.done && (h = x.return) && h.call(x);
        } finally {
          if (f)
            throw f.error;
        }
      }
      this.scheduler.clear(), this.scheduler = new ne({
        deferEvents: this.options.deferEvents
      });
    }, e.prototype.stop = function() {
      var t = this, r = this.scheduler;
      return this._stop(), r.schedule(function() {
        var n;
        if (!(!((n = t._state) === null || n === void 0) && n.done)) {
          var i = F({
            type: "xstate.stop"
          }), a = nt(t, function() {
            var o = C(k([], N(t.state.configuration), !1).sort(function(l, c) {
              return c.order - l.order;
            }).map(function(l) {
              return W(l.onExit, t.machine.options.actions);
            })), s = N(Pt(t.machine, t.state, t.state.context, i, [{
              type: "exit",
              actions: o
            }], t.machine.config.predictableActionArguments ? t._exec : void 0, t.machine.config.predictableActionArguments || t.machine.config.preserveActionOrder), 2), u = s[0], f = s[1], h = new Q({
              value: t.state.value,
              context: f,
              _event: i,
              _sessionid: t.sessionId,
              historyValue: void 0,
              history: t.state,
              actions: u.filter(function(l) {
                return !zt(l);
              }),
              activities: {},
              events: [],
              configuration: [],
              transitions: [],
              children: {},
              done: t.state.done,
              tags: t.state.tags,
              machine: t.machine
            });
            return h.changed = !0, h;
          });
          t.update(a, i), t._stopChildren(), ft.free(t.sessionId);
        }
      }), this;
    }, e.prototype.batch = function(t) {
      var r = this;
      if (this.status === U.NotStarted && this.options.deferEvents)
        M || $(!1, "".concat(t.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, `" and are deferred. Make sure .start() is called for this service.
Event: `).concat(JSON.stringify(event)));
      else if (this.status !== U.Running)
        throw new Error(
          // tslint:disable-next-line:max-line-length
          "".concat(t.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
        );
      if (t.length) {
        var n = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
          var i, a, o = r.state, s = !1, u = [], f = function(d) {
            var y = F(d);
            r.forward(y), o = nt(r, function() {
              return r.machine.transition(o, y, void 0, n || void 0);
            }), u.push.apply(u, k([], N(r.machine.config.predictableActionArguments ? o.actions : o.actions.map(function(p) {
              return or(p, o);
            })), !1)), s = s || !!o.changed;
          };
          try {
            for (var h = E(t), l = h.next(); !l.done; l = h.next()) {
              var c = l.value;
              f(c);
            }
          } catch (d) {
            i = {
              error: d
            };
          } finally {
            try {
              l && !l.done && (a = h.return) && a.call(h);
            } finally {
              if (i)
                throw i.error;
            }
          }
          o.changed = s, o.actions = u, r.update(o, F(t[t.length - 1]));
        });
      }
    }, e.prototype.sender = function(t) {
      return this.send.bind(this, t);
    }, e.prototype._nextState = function(t, r) {
      var n = this;
      r === void 0 && (r = !!this.machine.config.predictableActionArguments && this._exec);
      var i = F(t);
      if (i.name.indexOf(Wt) === 0 && !this.state.nextEvents.some(function(o) {
        return o.indexOf(Wt) === 0;
      }))
        throw i.data.data;
      var a = nt(this, function() {
        return n.machine.transition(n.state, i, void 0, r || void 0);
      });
      return a;
    }, e.prototype.nextState = function(t) {
      return this._nextState(t, !1);
    }, e.prototype.forward = function(t) {
      var r, n;
      try {
        for (var i = E(this.forwardTo), a = i.next(); !a.done; a = i.next()) {
          var o = a.value, s = this.children.get(o);
          if (!s)
            throw new Error("Unable to forward event '".concat(t, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(o, "'."));
          s.send(t);
        }
      } catch (u) {
        r = {
          error: u
        };
      } finally {
        try {
          a && !a.done && (n = i.return) && n.call(i);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }, e.prototype.defer = function(t) {
      var r = this, n = this.clock.setTimeout(function() {
        "to" in t && t.to ? r.sendTo(t._event, t.to, !0) : r.send(t._event);
      }, t.delay);
      t.id && (this.delayedEventsMap[t.id] = n);
    }, e.prototype.cancel = function(t) {
      this.clock.clearTimeout(this.delayedEventsMap[t]), delete this.delayedEventsMap[t];
    }, e.prototype.exec = function(t, r, n) {
      n === void 0 && (n = this.machine.options.actions), this._exec(t, r.context, r._event, n);
    }, e.prototype.removeChild = function(t) {
      var r;
      this.children.delete(t), this.forwardTo.delete(t), (r = this.state) === null || r === void 0 || delete r.children[t];
    }, e.prototype.stopChild = function(t) {
      var r = this.children.get(t);
      r && (this.removeChild(t), j(r.stop) && r.stop());
    }, e.prototype.spawn = function(t, r, n) {
      if (this.status !== U.Running)
        return ye(t, r);
      if (Ht(t))
        return this.spawnPromise(Promise.resolve(t), r);
      if (j(t))
        return this.spawnCallback(t, r);
      if (tr(t))
        return this.spawnActor(t, r);
      if (Me(t))
        return this.spawnObservable(t, r);
      if (Z(t))
        return this.spawnMachine(t, v(v({}, n), {
          id: r
        }));
      if (De(t))
        return this.spawnBehavior(t, r);
      throw new Error('Unable to spawn entity "'.concat(r, '" of type "').concat(typeof t, '".'));
    }, e.prototype.spawnMachine = function(t, r) {
      var n = this;
      r === void 0 && (r = {});
      var i = new e(t, v(v({}, this.options), {
        parent: this,
        id: r.id || t.id
      })), a = v(v({}, lr), r);
      a.sync && i.onTransition(function(s) {
        n.send(se, {
          state: s,
          id: i.id
        });
      });
      var o = i;
      return this.children.set(i.id, o), a.autoForward && this.forwardTo.add(i.id), i.onDone(function(s) {
        n.removeChild(i.id), n.send(F(s, {
          origin: i.id
        }));
      }).start(), o;
    }, e.prototype.spawnBehavior = function(t, r) {
      var n = hr(t, {
        id: r,
        parent: this
      });
      return this.children.set(r, n), n;
    }, e.prototype.spawnPromise = function(t, r) {
      var n, i = this, a = !1, o;
      t.then(function(u) {
        a || (o = u, i.removeChild(r), i.send(F(Tt(r, u), {
          origin: r
        })));
      }, function(u) {
        if (!a) {
          i.removeChild(r);
          var f = lt(r, u);
          try {
            i.send(F(f, {
              origin: r
            }));
          } catch (h) {
            ze(u, h, r), i.devTools && i.devTools.send(f, i.state), i.machine.strict && i.stop();
          }
        }
      });
      var s = (n = {
        id: r,
        send: function() {
        },
        subscribe: function(u, f, h) {
          var l = Ot(u, f, h), c = !1;
          return t.then(function(d) {
            c || (l.next(d), !c && l.complete());
          }, function(d) {
            c || l.error(d);
          }), {
            unsubscribe: function() {
              return c = !0;
            }
          };
        },
        stop: function() {
          a = !0;
        },
        toJSON: function() {
          return {
            id: r
          };
        },
        getSnapshot: function() {
          return o;
        }
      }, n[B] = function() {
        return this;
      }, n);
      return this.children.set(r, s), s;
    }, e.prototype.spawnCallback = function(t, r) {
      var n, i = this, a = !1, o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), u, f = function(c) {
        u = c, s.forEach(function(d) {
          return d(c);
        }), !a && i.send(F(c, {
          origin: r
        }));
      }, h;
      try {
        h = t(f, function(c) {
          o.add(c);
        });
      } catch (c) {
        this.send(lt(r, c));
      }
      if (Ht(h))
        return this.spawnPromise(h, r);
      var l = (n = {
        id: r,
        send: function(c) {
          return o.forEach(function(d) {
            return d(c);
          });
        },
        subscribe: function(c) {
          var d = Ot(c);
          return s.add(d.next), {
            unsubscribe: function() {
              s.delete(d.next);
            }
          };
        },
        stop: function() {
          a = !0, j(h) && h();
        },
        toJSON: function() {
          return {
            id: r
          };
        },
        getSnapshot: function() {
          return u;
        }
      }, n[B] = function() {
        return this;
      }, n);
      return this.children.set(r, l), l;
    }, e.prototype.spawnObservable = function(t, r) {
      var n, i = this, a, o = t.subscribe(function(u) {
        a = u, i.send(F(u, {
          origin: r
        }));
      }, function(u) {
        i.removeChild(r), i.send(F(lt(r, u), {
          origin: r
        }));
      }, function() {
        i.removeChild(r), i.send(F(Tt(r), {
          origin: r
        }));
      }), s = (n = {
        id: r,
        send: function() {
        },
        subscribe: function(u, f, h) {
          return t.subscribe(u, f, h);
        },
        stop: function() {
          return o.unsubscribe();
        },
        getSnapshot: function() {
          return a;
        },
        toJSON: function() {
          return {
            id: r
          };
        }
      }, n[B] = function() {
        return this;
      }, n);
      return this.children.set(r, s), s;
    }, e.prototype.spawnActor = function(t, r) {
      return this.children.set(r, t), t;
    }, e.prototype.spawnActivity = function(t) {
      var r = this.machine.options && this.machine.options.activities ? this.machine.options.activities[t.type] : void 0;
      if (!r) {
        M || $(!1, "No implementation found for activity '".concat(t.type, "'"));
        return;
      }
      var n = r(this.state.context, t);
      this.spawnEffect(t.id, n);
    }, e.prototype.spawnEffect = function(t, r) {
      var n;
      this.children.set(t, (n = {
        id: t,
        send: function() {
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
            }
          };
        },
        stop: r || void 0,
        getSnapshot: function() {
        },
        toJSON: function() {
          return {
            id: t
          };
        }
      }, n[B] = function() {
        return this;
      }, n));
    }, e.prototype.attachDev = function() {
      var t = Vt();
      if (this.options.devTools && t) {
        if (t.__REDUX_DEVTOOLS_EXTENSION__) {
          var r = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
          this.devTools = t.__REDUX_DEVTOOLS_EXTENSION__.connect(v(v({
            name: this.id,
            autoPause: !0,
            stateSanitizer: function(n) {
              return {
                value: n.value,
                context: n.context,
                actions: n.actions
              };
            }
          }, r), {
            features: v({
              jump: !1,
              skip: !1
            }, r ? r.features : void 0)
          }), this.machine), this.devTools.init(this.state);
        }
        cr(this);
      }
    }, e.prototype.toJSON = function() {
      return {
        id: this.id
      };
    }, e.prototype[B] = function() {
      return this;
    }, e.prototype.getSnapshot = function() {
      return this.status === U.NotStarted ? this.initialState : this._state;
    }, e.defaultOptions = {
      execute: !0,
      deferEvents: !0,
      clock: {
        setTimeout: function(t, r) {
          return setTimeout(t, r);
        },
        clearTimeout: function(t) {
          return clearTimeout(t);
        }
      },
      logger: /* @__PURE__ */ console.log.bind(console),
      devTools: !1
    }, e.interpret = vr, e;
  }()
);
function vr(e, t) {
  var r = new dr(e, t);
  return r;
}
function pr(e) {
  if (typeof e == "string") {
    var t = {
      type: e
    };
    return t.toString = function() {
      return e;
    }, t;
  }
  return e;
}
function bt(e) {
  return v(v({
    type: Mt
  }, e), {
    toJSON: function() {
      e.onDone, e.onError;
      var t = Gt(e, ["onDone", "onError"]);
      return v(v({}, t), {
        type: Mt,
        src: pr(e.src)
      });
    }
  });
}
var it = "", Jt = "#", ct = "*", et = {}, rt = function(e) {
  return e[0] === Jt;
}, yr = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
}, gr = function(e, t, r) {
  var n = r.slice(0, -1).some(function(a) {
    return !("cond" in a) && !("in" in a) && (A(a.target) || Z(a.target));
  }), i = t === it ? "the transient event" : "event '".concat(t, "'");
  $(!n, "One or more transitions for ".concat(i, " on state '").concat(e.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
}, mr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r, n, i) {
      n === void 0 && (n = "context" in t ? t.context : void 0);
      var a = this, o;
      this.config = t, this._context = n, this.order = -1, this.__xstatenode = !0, this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign(yr(), r), this.parent = i == null ? void 0 : i.parent, this.key = this.config.key || (i == null ? void 0 : i.key) || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : ue), this.id = this.config.id || k([this.machine.key], N(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (o = this.config.schema) !== null && o !== void 0 ? o : {}, this.description = this.config.description, M || $(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead.")), this.initial = this.config.initial, this.states = this.config.states ? ht(this.config.states, function(f, h) {
        var l, c = new e(f, {}, void 0, {
          parent: a,
          key: h
        });
        return Object.assign(a.idMap, v((l = {}, l[c.id] = c, l), c.idMap)), c;
      }) : et;
      var s = 0;
      function u(f) {
        var h, l;
        f.order = s++;
        try {
          for (var c = E(ge(f)), d = c.next(); !d.done; d = c.next()) {
            var y = d.value;
            u(y);
          }
        } catch (p) {
          h = {
            error: p
          };
        } finally {
          try {
            d && !d.done && (l = c.return) && l.call(c);
          } finally {
            if (h)
              throw h.error;
          }
        }
      }
      u(this), this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(f) {
        var h = f.event;
        return h === it;
      }) : it in this.config.on : !1), this.strict = !!this.config.strict, this.onEntry = q(this.config.entry || this.config.onEntry).map(function(f) {
        return yt(f);
      }), this.onExit = q(this.config.exit || this.config.onExit).map(function(f) {
        return yt(f);
      }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = q(this.config.invoke).map(function(f, h) {
        var l, c;
        if (Z(f)) {
          var d = St(a.id, h);
          return a.machine.options.services = v((l = {}, l[d] = f, l), a.machine.options.services), bt({
            src: d,
            id: d
          });
        } else if (A(f.src)) {
          var d = f.id || St(a.id, h);
          return bt(v(v({}, f), {
            id: d,
            src: f.src
          }));
        } else if (Z(f.src) || j(f.src)) {
          var d = f.id || St(a.id, h);
          return a.machine.options.services = v((c = {}, c[d] = f.src, c), a.machine.options.services), bt(v(v({
            id: d
          }, f), {
            src: d
          }));
        } else {
          var y = f.src;
          return bt(v(v({
            id: St(a.id, h)
          }, f), {
            src: y
          }));
        }
      }), this.activities = q(this.config.activities).concat(this.invoke).map(function(f) {
        return Qt(f);
      }), this.transition = this.transition.bind(this), this.tags = q(this.config.tags);
    }
    return e.prototype._init = function() {
      this.__cache.transitions || me(this).forEach(function(t) {
        return t.on;
      });
    }, e.prototype.withConfig = function(t, r) {
      var n = this.options, i = n.actions, a = n.activities, o = n.guards, s = n.services, u = n.delays;
      return new e(this.config, {
        actions: v(v({}, i), t.actions),
        activities: v(v({}, a), t.activities),
        guards: v(v({}, o), t.guards),
        services: v(v({}, s), t.services),
        delays: v(v({}, u), t.delays)
      }, r ?? this.context);
    }, e.prototype.withContext = function(t) {
      return new e(this.config, this.options, t);
    }, Object.defineProperty(e.prototype, "context", {
      get: function() {
        return j(this._context) ? this._context() : this._context;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: ht(this.states, function(t) {
            return t.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toJSON = function() {
      return this.definition;
    }, Object.defineProperty(e.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on)
          return this.__cache.on;
        var t = this.transitions;
        return this.__cache.on = t.reduce(function(r, n) {
          return r[n.eventType] = r[n.eventType] || [], r[n.eventType].push(n), r;
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getCandidates = function(t) {
      if (this.__cache.candidates[t])
        return this.__cache.candidates[t];
      var r = t === it, n = this.transitions.filter(function(i) {
        var a = i.eventType === t;
        return r ? a : a || i.eventType === ct;
      });
      return this.__cache.candidates[t] = n, n;
    }, e.prototype.getDelayedTransitions = function() {
      var t = this, r = this.config.after;
      if (!r)
        return [];
      var n = function(a, o) {
        var s = j(a) ? "".concat(t.id, ":delay[").concat(o, "]") : a, u = We(s, t.id);
        return t.onEntry.push(Je(u, {
          delay: a
        })), t.onExit.push(Ye(u)), u;
      }, i = st(r) ? r.map(function(a, o) {
        var s = n(a.delay, o);
        return v(v({}, a), {
          event: s
        });
      }) : C(Object.keys(r).map(function(a, o) {
        var s = r[a], u = A(s) ? {
          target: s
        } : s, f = isNaN(+a) ? a : +a, h = n(f, o);
        return q(u).map(function(l) {
          return v(v({}, l), {
            event: h,
            delay: f
          });
        });
      }));
      return i.map(function(a) {
        var o = a.delay;
        return v(v({}, t.formatTransition(a)), {
          delay: o
        });
      });
    }, e.prototype.getStateNodes = function(t) {
      var r, n = this;
      if (!t)
        return [];
      var i = t instanceof Q ? t.value : pt(t, this.delimiter);
      if (A(i)) {
        var a = this.getStateNode(i).initial;
        return a !== void 0 ? this.getStateNodes((r = {}, r[i] = a, r)) : [this, this.states[i]];
      }
      var o = Object.keys(i), s = [this];
      return s.push.apply(s, k([], N(C(o.map(function(u) {
        return n.getStateNode(u).getStateNodes(i[u]);
      }))), !1)), s;
    }, e.prototype.handles = function(t) {
      var r = fe(t);
      return this.events.includes(r);
    }, e.prototype.resolveState = function(t) {
      var r = t instanceof Q ? t : Q.create(t), n = Array.from(dt([], this.getStateNodes(r.value)));
      return new Q(v(v({}, r), {
        value: this.resolve(r.value),
        configuration: n,
        done: Nt(n, this),
        tags: re(n),
        machine: this.machine
      }));
    }, e.prototype.transitionLeafNode = function(t, r, n) {
      var i = this.getStateNode(t), a = i.next(r, n);
      return !a || !a.transitions.length ? this.next(r, n) : a;
    }, e.prototype.transitionCompoundNode = function(t, r, n) {
      var i = Object.keys(t), a = this.getStateNode(i[0]), o = a._transition(t[i[0]], r, n);
      return !o || !o.transitions.length ? this.next(r, n) : o;
    }, e.prototype.transitionParallelNode = function(t, r, n) {
      var i, a, o = {};
      try {
        for (var s = E(Object.keys(t)), u = s.next(); !u.done; u = s.next()) {
          var f = u.value, h = t[f];
          if (h) {
            var l = this.getStateNode(f), c = l._transition(h, r, n);
            c && (o[f] = c);
          }
        }
      } catch (m) {
        i = {
          error: m
        };
      } finally {
        try {
          u && !u.done && (a = s.return) && a.call(s);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var d = Object.keys(o).map(function(m) {
        return o[m];
      }), y = C(d.map(function(m) {
        return m.transitions;
      })), p = d.some(function(m) {
        return m.transitions.length > 0;
      });
      if (!p)
        return this.next(r, n);
      var S = C(Object.keys(o).map(function(m) {
        return o[m].configuration;
      }));
      return {
        transitions: y,
        exitSet: C(d.map(function(m) {
          return m.exitSet;
        })),
        configuration: S,
        source: r,
        actions: C(Object.keys(o).map(function(m) {
          return o[m].actions;
        }))
      };
    }, e.prototype._transition = function(t, r, n) {
      return A(t) ? this.transitionLeafNode(t, r, n) : Object.keys(t).length === 1 ? this.transitionCompoundNode(t, r, n) : this.transitionParallelNode(t, r, n);
    }, e.prototype.getTransitionData = function(t, r) {
      return this._transition(t.value, t, F(r));
    }, e.prototype.next = function(t, r) {
      var n, i, a = this, o = r.name, s = [], u = [], f;
      try {
        for (var h = E(this.getCandidates(o)), l = h.next(); !l.done; l = h.next()) {
          var c = l.value, d = c.cond, y = c.in, p = t.context, S = y ? A(y) && rt(y) ? (
            // Check if in state by ID
            t.matches(pt(this.getStateNodeById(y).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            qt(pt(y, this.delimiter), Le(this.path.slice(0, -2))(t.value))
          ) : !0, m = !1;
          try {
            m = !d || de(this.machine, d, p, r, t);
          } catch (x) {
            throw new Error("Unable to evaluate guard '".concat(d.name || d.type, "' in transition for event '").concat(o, "' in state node '").concat(this.id, `':
`).concat(x.message));
          }
          if (m && S) {
            c.target !== void 0 && (u = c.target), s.push.apply(s, k([], N(c.actions), !1)), f = c;
            break;
          }
        }
      } catch (x) {
        n = {
          error: x
        };
      } finally {
        try {
          l && !l.done && (i = h.return) && i.call(h);
        } finally {
          if (n)
            throw n.error;
        }
      }
      if (f) {
        if (!u.length)
          return {
            transitions: [f],
            exitSet: [],
            configuration: t.value ? [this] : [],
            source: t,
            actions: s
          };
        var g = C(u.map(function(x) {
          return a.getRelativeStateNodes(x, t.historyValue);
        })), w = !!f.internal;
        return {
          transitions: [f],
          exitSet: w ? [] : C(u.map(function(x) {
            return a.getPotentiallyReenteringNodes(x);
          })),
          configuration: g,
          source: t,
          actions: s
        };
      }
    }, e.prototype.getPotentiallyReenteringNodes = function(t) {
      if (this.order < t.order)
        return [this];
      for (var r = [], n = this, i = t; n && n !== i; )
        r.push(n), n = n.parent;
      return n !== i ? [] : (r.push(i), r);
    }, e.prototype.getActions = function(t, r, n, i, a, o, s) {
      var u, f, h, l, c = this, d = o ? dt([], this.getStateNodes(o.value)) : [], y = /* @__PURE__ */ new Set();
      try {
        for (var p = E(Array.from(t).sort(function(b, D) {
          return b.order - D.order;
        })), S = p.next(); !S.done; S = p.next()) {
          var m = S.value;
          (!vt(d, m) || vt(n.exitSet, m) || m.parent && y.has(m.parent)) && y.add(m);
        }
      } catch (b) {
        u = {
          error: b
        };
      } finally {
        try {
          S && !S.done && (f = p.return) && f.call(p);
        } finally {
          if (u)
            throw u.error;
        }
      }
      try {
        for (var g = E(d), w = g.next(); !w.done; w = g.next()) {
          var m = w.value;
          (!vt(t, m) || vt(n.exitSet, m.parent)) && n.exitSet.push(m);
        }
      } catch (b) {
        h = {
          error: b
        };
      } finally {
        try {
          w && !w.done && (l = g.return) && l.call(g);
        } finally {
          if (h)
            throw h.error;
        }
      }
      n.exitSet.sort(function(b, D) {
        return D.order - b.order;
      });
      var x = Array.from(y).sort(function(b, D) {
        return b.order - D.order;
      }), R = new Set(n.exitSet), P = C(x.map(function(b) {
        var D = [];
        if (b.type !== "final")
          return D;
        var z = b.parent;
        if (!z.parent)
          return D;
        D.push(
          xt(b.id, b.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          xt(z.id, b.doneData ? jt(b.doneData, i, a) : void 0)
        );
        var J = z.parent;
        return J.type === "parallel" && gt(J).every(function(ut) {
          return Nt(n.configuration, ut);
        }) && D.push(xt(J.id)), D;
      })), T = x.map(function(b) {
        var D = b.onEntry, z = b.activities.map(function(J) {
          return qe(J);
        });
        return {
          type: "entry",
          actions: W(s ? k(k([], N(D), !1), N(z), !1) : k(k([], N(z), !1), N(D), !1), c.machine.options.actions)
        };
      }).concat({
        type: "state_done",
        actions: P.map(function(b) {
          return Fe(b);
        })
      }), I = Array.from(R).map(function(b) {
        return {
          type: "exit",
          actions: W(k(k([], N(b.onExit), !1), N(b.activities.map(function(D) {
            return Qe(D);
          })), !1), c.machine.options.actions)
        };
      }), O = I.concat({
        type: "transition",
        actions: W(n.actions, this.machine.options.actions)
      }).concat(T);
      if (r) {
        var _ = W(C(k([], N(t), !1).sort(function(b, D) {
          return D.order - b.order;
        }).map(function(b) {
          return b.onExit;
        })), this.machine.options.actions).filter(function(b) {
          return !zt(b);
        });
        return O.concat({
          type: "stop",
          actions: _
        });
      }
      return O;
    }, e.prototype.transition = function(t, r, n, i) {
      t === void 0 && (t = this.initialState);
      var a = F(r), o;
      if (t instanceof Q)
        o = n === void 0 ? t : this.resolveState(Q.from(t, n));
      else {
        var s = A(t) ? this.resolve(At(this.getResolvedPath(t))) : this.resolve(t), u = n ?? this.machine.context;
        o = this.resolveState(Q.from(s, u));
      }
      if (!M && a.name === ct)
        throw new Error("An event cannot have the wildcard type ('".concat(ct, "')"));
      if (this.strict && !this.events.includes(a.name) && !Re(a.name))
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(a.name, "'"));
      var f = this._transition(o.value, o, a) || {
        transitions: [],
        configuration: [],
        exitSet: [],
        source: o,
        actions: []
      }, h = dt([], this.getStateNodes(o.value)), l = f.configuration.length ? dt(h, f.configuration) : h;
      return f.configuration = k([], N(l), !1), this.resolveTransition(f, o, o.context, i, a);
    }, e.prototype.resolveRaisedTransition = function(t, r, n, i) {
      var a, o = t.actions;
      return t = this.transition(t, r, void 0, i), t._event = n, t.event = n.data, (a = t.actions).unshift.apply(a, k([], N(o), !1)), t;
    }, e.prototype.resolveTransition = function(t, r, n, i, a) {
      var o, s, u, f, h = this;
      a === void 0 && (a = at);
      var l = t.configuration, c = !r || t.transitions.length > 0, d = c ? t.configuration : r ? r.configuration : [], y = Nt(d, this), p = c ? rr(this.machine, l) : void 0, S = r ? r.historyValue ? r.historyValue : t.source ? this.machine.historyValue(r.value) : void 0 : void 0, m = this.getActions(new Set(d), y, t, n, a, r, i), g = r ? v({}, r.activities) : {};
      try {
        for (var w = E(m), x = w.next(); !x.done; x = w.next()) {
          var R = x.value;
          try {
            for (var P = (u = void 0, E(R.actions)), T = P.next(); !T.done; T = P.next()) {
              var I = T.value;
              I.type === Ct ? g[I.activity.id || I.activity.type] = I : I.type === Xt && (g[I.activity.id || I.activity.type] = !1);
            }
          } catch (Y) {
            u = {
              error: Y
            };
          } finally {
            try {
              T && !T.done && (f = P.return) && f.call(P);
            } finally {
              if (u)
                throw u.error;
            }
          }
        }
      } catch (Y) {
        o = {
          error: Y
        };
      } finally {
        try {
          x && !x.done && (s = w.return) && s.call(w);
        } finally {
          if (o)
            throw o.error;
        }
      }
      var O = N(Pt(this, r, n, a, m, i, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), _ = O[0], b = O[1], D = N(ke(_, zt), 2), z = D[0], J = D[1], ut = _.filter(function(Y) {
        var H;
        return Y.type === Ct && ((H = Y.activity) === null || H === void 0 ? void 0 : H.type) === Mt;
      }), Dt = ut.reduce(function(Y, H) {
        return Y[H.activity.id] = Ze(H.activity, h.machine, b, a), Y;
      }, r ? v({}, r.children) : {}), K = new Q({
        value: p || r.value,
        context: b,
        _event: a,
        // Persist _sessionid between states
        _sessionid: r ? r._sessionid : null,
        historyValue: p ? S ? Ce(S, p) : void 0 : r ? r.historyValue : void 0,
        history: !p || t.source ? r : void 0,
        actions: p ? J : [],
        activities: p ? g : r ? r.activities : {},
        events: [],
        configuration: d,
        transitions: t.transitions,
        children: Dt,
        done: y,
        tags: re(d),
        machine: this
      }), V = n !== b;
      K.changed = a.name === se || V;
      var G = K.history;
      G && delete G.history;
      var Bt = !y && (this._transient || l.some(function(Y) {
        return Y._transient;
      }));
      if (!c && (!Bt || a.name === it))
        return K;
      var X = K;
      if (!y)
        for (Bt && (X = this.resolveRaisedTransition(X, {
          type: Ee
        }, a, i)); z.length; ) {
          var xe = z.shift();
          X = this.resolveRaisedTransition(X, xe._event, a, i);
        }
      var be = X.changed || (G ? !!X.actions.length || V || typeof G.value != typeof X.value || !Se(X.value, G.value) : void 0);
      return X.changed = be, X.history = G, X;
    }, e.prototype.getStateNode = function(t) {
      if (rt(t))
        return this.machine.getStateNodeById(t);
      if (!this.states)
        throw new Error("Unable to retrieve child state '".concat(t, "' from '").concat(this.id, "'; no child states exist."));
      var r = this.states[t];
      if (!r)
        throw new Error("Child state '".concat(t, "' does not exist on '").concat(this.id, "'"));
      return r;
    }, e.prototype.getStateNodeById = function(t) {
      var r = rt(t) ? t.slice(Jt.length) : t;
      if (r === this.id)
        return this;
      var n = this.machine.idMap[r];
      if (!n)
        throw new Error("Child state node '#".concat(r, "' does not exist on machine '").concat(this.id, "'"));
      return n;
    }, e.prototype.getStateNodeByPath = function(t) {
      if (typeof t == "string" && rt(t))
        try {
          return this.getStateNodeById(t.slice(1));
        } catch {
        }
      for (var r = Ut(t, this.delimiter).slice(), n = this; r.length; ) {
        var i = r.shift();
        if (!i.length)
          break;
        n = n.getStateNode(i);
      }
      return n;
    }, e.prototype.resolve = function(t) {
      var r, n = this;
      if (!t)
        return this.initialStateValue || et;
      switch (this.type) {
        case "parallel":
          return ht(this.initialStateValue, function(a, o) {
            return a ? n.getStateNode(o).resolve(t[o] || a) : et;
          });
        case "compound":
          if (A(t)) {
            var i = this.getStateNode(t);
            return i.type === "parallel" || i.type === "compound" ? (r = {}, r[t] = i.initialStateValue, r) : t;
          }
          return Object.keys(t).length ? ht(t, function(a, o) {
            return a ? n.getStateNode(o).resolve(a) : et;
          }) : this.initialStateValue || {};
        default:
          return t || et;
      }
    }, e.prototype.getResolvedPath = function(t) {
      if (rt(t)) {
        var r = this.machine.idMap[t.slice(Jt.length)];
        if (!r)
          throw new Error("Unable to find state node '".concat(t, "'"));
        return r.path;
      }
      return Ut(t, this.delimiter);
    }, Object.defineProperty(e.prototype, "initialStateValue", {
      get: function() {
        var t;
        if (this.__cache.initialStateValue)
          return this.__cache.initialStateValue;
        var r;
        if (this.type === "parallel")
          r = Zt(this.states, function(n) {
            return n.initialStateValue || et;
          }, function(n) {
            return n.type !== "history";
          });
        else if (this.initial !== void 0) {
          if (!this.states[this.initial])
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          r = Lt(this.states[this.initial]) ? this.initial : (t = {}, t[this.initial] = this.states[this.initial].initialStateValue, t);
        } else
          r = {};
        return this.__cache.initialStateValue = r, this.__cache.initialStateValue;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getInitialState = function(t, r) {
      this._init();
      var n = this.getStateNodes(t);
      return this.resolveTransition({
        configuration: n,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, r ?? this.machine.context, void 0);
    }, Object.defineProperty(e.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var t = this.initialStateValue;
        if (!t)
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var t;
        if (this.type === "history") {
          var r = this.config;
          A(r.target) ? t = rt(r.target) ? At(this.machine.getStateNodeById(r.target).path.slice(this.path.length - 1)) : r.target : t = r.target;
        }
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getRelativeStateNodes = function(t, r, n) {
      return n === void 0 && (n = !0), n ? t.type === "history" ? t.resolveHistory(r) : t.initialStateNodes : [t];
    }, Object.defineProperty(e.prototype, "initialStateNodes", {
      get: function() {
        var t = this;
        if (Lt(this))
          return [this];
        if (this.type === "compound" && !this.initial)
          return M || $(!1, "Compound state node '".concat(this.id, "' has no initial state.")), [this];
        var r = Et(this.initialStateValue);
        return C(r.map(function(n) {
          return t.getFromRelativePath(n);
        }));
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getFromRelativePath = function(t) {
      if (!t.length)
        return [this];
      var r = N(t), n = r[0], i = r.slice(1);
      if (!this.states)
        throw new Error("Cannot retrieve subPath '".concat(n, "' from node with no states"));
      var a = this.getStateNode(n);
      if (a.type === "history")
        return a.resolveHistory();
      if (!this.states[n])
        throw new Error("Child state '".concat(n, "' does not exist on '").concat(this.id, "'"));
      return this.states[n].getFromRelativePath(i);
    }, e.prototype.historyValue = function(t) {
      if (Object.keys(this.states).length)
        return {
          current: t || this.initialStateValue,
          states: Zt(this.states, function(r, n) {
            if (!t)
              return r.historyValue();
            var i = A(t) ? void 0 : t[n];
            return r.historyValue(i || r.initialStateValue);
          }, function(r) {
            return !r.history;
          })
        };
    }, e.prototype.resolveHistory = function(t) {
      var r = this;
      if (this.type !== "history")
        return [this];
      var n = this.parent;
      if (!t) {
        var i = this.target;
        return i ? C(Et(i).map(function(o) {
          return n.getFromRelativePath(o);
        })) : n.initialStateNodes;
      }
      var a = Ie(n.path, "states")(t).current;
      return A(a) ? [n.getStateNode(a)] : C(Et(a).map(function(o) {
        return r.history === "deep" ? n.getFromRelativePath(o) : [n.states[o[0]]];
      }));
    }, Object.defineProperty(e.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var t = this, r = C(Object.keys(this.states).map(function(n) {
          return t.states[n].stateIds;
        }));
        return [this.id].concat(r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var t, r, n, i;
        if (this.__cache.events)
          return this.__cache.events;
        var a = this.states, o = new Set(this.ownEvents);
        if (a)
          try {
            for (var s = E(Object.keys(a)), u = s.next(); !u.done; u = s.next()) {
              var f = u.value, h = a[f];
              if (h.states)
                try {
                  for (var l = (n = void 0, E(h.events)), c = l.next(); !c.done; c = l.next()) {
                    var d = c.value;
                    o.add("".concat(d));
                  }
                } catch (y) {
                  n = {
                    error: y
                  };
                } finally {
                  try {
                    c && !c.done && (i = l.return) && i.call(l);
                  } finally {
                    if (n)
                      throw n.error;
                  }
                }
            }
          } catch (y) {
            t = {
              error: y
            };
          } finally {
            try {
              u && !u.done && (r = s.return) && r.call(s);
            } finally {
              if (t)
                throw t.error;
            }
          }
        return this.__cache.events = Array.from(o);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var t = new Set(this.transitions.filter(function(r) {
          return !(!r.target && !r.actions.length && r.internal);
        }).map(function(r) {
          return r.eventType;
        }));
        return Array.from(t);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolveTarget = function(t) {
      var r = this;
      if (t !== void 0)
        return t.map(function(n) {
          if (!A(n))
            return n;
          var i = n[0] === r.delimiter;
          if (i && !r.parent)
            return r.getStateNodeByPath(n.slice(1));
          var a = i ? r.key + n : n;
          if (r.parent)
            try {
              var o = r.parent.getStateNodeByPath(a);
              return o;
            } catch (s) {
              throw new Error("Invalid transition definition for state node '".concat(r.id, `':
`).concat(s.message));
            }
          else
            return r.getStateNodeByPath(a);
        });
    }, e.prototype.formatTransition = function(t) {
      var r = this, n = Ue(t.target), i = "internal" in t ? t.internal : n ? n.some(function(u) {
        return A(u) && u[0] === r.delimiter;
      }) : !0, a = this.machine.options.guards, o = this.resolveTarget(n), s = v(v({}, t), {
        actions: W(q(t.actions)),
        cond: le(t.cond, a),
        target: o,
        source: this,
        internal: i,
        eventType: t.event,
        toJSON: function() {
          return v(v({}, s), {
            target: s.target ? s.target.map(function(u) {
              return "#".concat(u.id);
            }) : void 0,
            source: "#".concat(r.id)
          });
        }
      });
      return s;
    }, e.prototype.formatTransitions = function() {
      var t, r, n = this, i;
      if (!this.config.on)
        i = [];
      else if (Array.isArray(this.config.on))
        i = this.config.on;
      else {
        var a = this.config.on, o = ct, s = a[o], u = s === void 0 ? [] : s, f = Gt(a, [typeof o == "symbol" ? o : o + ""]);
        i = C(Object.keys(f).map(function(g) {
          !M && g === it && $(!1, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(n.id, '".'));
          var w = tt(g, f[g]);
          return M || gr(n, g, w), w;
        }).concat(tt(ct, u)));
      }
      var h = this.config.always ? tt("", this.config.always) : [], l = this.config.onDone ? tt(String(xt(this.id)), this.config.onDone) : [];
      M || $(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
      var c = C(this.invoke.map(function(g) {
        var w = [];
        return g.onDone && w.push.apply(w, k([], N(tt(String(Tt(g.id)), g.onDone)), !1)), g.onError && w.push.apply(w, k([], N(tt(String(lt(g.id)), g.onError)), !1)), w;
      })), d = this.after, y = C(k(k(k(k([], N(l), !1), N(c), !1), N(i), !1), N(h), !1).map(function(g) {
        return q(g).map(function(w) {
          return n.formatTransition(w);
        });
      }));
      try {
        for (var p = E(d), S = p.next(); !S.done; S = p.next()) {
          var m = S.value;
          y.push(m);
        }
      } catch (g) {
        t = {
          error: g
        };
      } finally {
        try {
          S && !S.done && (r = p.return) && r.call(p);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return y;
    }, e;
  }()
), ie = !1;
function wr(e, t) {
  return !M && !("predictableActionArguments" in e) && !ie && (ie = !0, console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html")), new mr(e, t);
}
var Sr = Be;
export {
  U as I,
  Q as S,
  Sr as a,
  wr as c,
  vr as i
};
